<app-title-section></app-title-section>

<div class="card" style="margin-left: 15px; margin-right: 15px">

    <div style="margin-left: 24px" class="row justify-content-left p-0">
        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #134AD34D;">
                <div class="benef-box__header">
                    <span class="iconDesing2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                            <path d="M2 15h10"/>
                            <path d="m9 18 3-3-3-3"/>
                        </svg>
                    </span>
                    <h2 class="size18 mb-0">Rapport de vente</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Vente par client')">Vente par client</p>
                    <p (click)="openReport('Détails ventes par ligne produit')">Détails ventes par ligne produit</p>
                    <p (click)="openReport('Transactions client')">Transactions client</p>
                    <p (click)="openReport('TVA ventes')">TVA ventes</p>
                    <p (click)="openReport('Total des retenues pour les clients')">Total des retenues pour les clients</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #134AD3B2;">
                <div class="benef-box__header">
                    <span class="iconDesing2">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M4 22h14a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v4"/>
                            <path d="M14 2v4a2 2 0 0 0 2 2h4"/>
                            <path d="M2 15h10"/>
                            <path d="m9 18 3-3-3-3"/>
                        </svg>
                    </span>
                    <h2 class="size18 mb-0">Rapport d'achat</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Achat par fournisseur')">Achat par fournisseur</p>
                    <p (click)="openReport('Détails d\u0027achat par ligne produit')">Détails d'achat par ligne produit</p>
                    <p (click)="openReport('Transactions fournisseurs')">Transactions fournisseurs</p>
                    <p (click)="openReport('TVA achat')">TVA achat</p>
                    <p (click)="openReport('Total des retenues pour les fournisseurs')">Total des retenues pour les fournisseurs</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #ED90384D;">
                <div class="benef-box__header">
                    <span class="iconDesing3">
                        <i data-feather="package" [size]="18"></i>
                    </span>
                    <h2 class="size18 mb-0">Détails vente par ligne produit</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Chiffre d’affaires par produit')">Chiffre d’affaires par produit</p>
                    <p (click)="openReport('Chiffre d’affaires par catégorie')">Chiffre d’affaires par catégorie</p>
                    <p (click)="openReport('Chiffre d’affaires par produit par client')">Chiffre d’affaires par produit par client</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #ED9038B2;">
                <div class="benef-box__header">
                    <span class="iconDesing3">
                        <i data-feather="users" [size]="18"></i>
                    </span>
                    <h2 class="size18 mb-0">Rapport stock</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Mouvement détaillé de stock')">Mouvement détaillé de stock</p>
                    <p (click)="openReport('Etat de stock à une date antérieure')">Etat de stock à une date antérieure</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #00A20E4D;">
                <div class="benef-box__header">
                    <span class="iconDesing4">
                        <i class="bi bi-coin" style="font-size:18px;"></i>
                    </span>
                    <h2 class="size18 mb-0">Rapport de paiement</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Paiement clients')">Paiement clients</p>
                    <p (click)="openReport('Paiements fournisseurs')">Paiements fournisseurs</p>
                    <p (click)="openReport('Facture clients payées depuis plus d\u0027un mois')">Facture clients payées depuis plus d'un mois</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #00A20EB2;">
                <div class="benef-box__header">
                    <span class="iconDesing4">
                        <i class="bi bi-graph-up-arrow" style="font-size:18px;"></i>
                    </span>
                    <h2 class="size18 mb-0">Rapport Bénéfices</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Bénéfice commercial par pièce')">Bénéfice commercial par pièce</p>
                    <p (click)="openReport('Bénéfice commercial mensuel')">Bénéfice commercial mensuel</p>
                    <p (click)="openReport('Bénéfice commercial par ligne')">Bénéfice commercial par ligne</p>
                    <p (click)="openReport('Bénéfice commercial par produit')">Bénéfice commercial par produit</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #00BAD14D;">
                <div class="benef-box__header">
                    <span class="iconDesing5">
                        <i class="bi bi-truck" style="font-size:18px;"></i>
                    </span>
                    <h2 class="size18 mb-0">Rapport client</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Chiffre d\u0027affaire par client')">Chiffre d'affaire par client</p>
                    <p (click)="openReport('Solde client')">Solde client</p>
                </div>
            </div>
        </div>


        <div class="row justify-content-left pb-0" style="margin-bottom: 49px; margin-right: 24px; margin-top: 24px">
            <div class="border-dashed rounded benef-box" style="margin-left: 24px; margin-top: 24px; border-bottom: 2px solid #00BAD1B2;">
                <div class="benef-box__header">
                    <span class="iconDesing5">
                        <i data-feather="user" [size]="18"></i>
                    </span>
                    <h2 class="size18 mb-0">Rapport fournisseur</h2>
                </div>

                <div class="items" style="color: #2F2B3DE5">
                    <p (click)="openReport('Chiffre d\u0027affaires par fournisseur')">Chiffre d'affaires par fournisseur</p>
                    <p (click)="openReport('Solde fournisseur')">Solde fournisseur</p>
                </div>
            </div>
        </div>


        <!-- auto
        <div *ngFor="let card of reportCards" class="row justify-content-left text-center p-2">
            <div class="border-dashed rounded  text-center benef-box">

                <div class="flex items-center gap-3 mb-4" (click)="openReport()">
                    <div class="p-2 rounded-lg" [ngStyle]="{ backgroundColor: card.bgColor }">
                        <i [class]="'lucide lucide-' + card.icon + ' w-5 h-5'" [ngStyle]="{ color: card.color }"></i>
                    </div>
                    <h2 class="text-gray-800 font-semibold text-base">{{ card.title }}</h2>
                </div>


                <span class="space-y-1 text-sm text-gray-600">
                    <p *ngFor="let report of card.reports" class="cursor-pointer hover:text-primary">
                        {{ report }}
                    </p>
                </span>
            </div>
        </div>-->


    </div>


</div>
